export const MAX_STRING_FILTER_COMBINATIONS = 4

export const PLAN_TIERS = {
  FREE: "Free",
  BUILD: "Build",
  SCALE: "Scale",
}

// Maps the server's canonical `subscription.slug` (from `plans.get_plan` in
// the backend) to the UI's tier label. Enterprise has unlimited caps server-
// side; the UI treats it as SCALE for `PLAN_LIMITS` table purposes until a
// dedicated ENTERPRISE row exists here.
const SLUG_TO_TIER = {
  build: PLAN_TIERS.BUILD,
  scale: PLAN_TIERS.SCALE,
  enterprise: PLAN_TIERS.SCALE,
}

export const PLAN_LIMITS = {
  [PLAN_TIERS.FREE]: {
    maxDatasets: 0,
    maxSchemasPerDataset: 0,
    maxRecordsPerSchema: 0,
    maxFieldsPerSchema: 0,
  },
  [PLAN_TIERS.BUILD]: {
    maxDatasets: 1,
    maxSchemasPerDataset: 3,
    maxRecordsPerSchema: 50000,
    maxFieldsPerSchema: 12,
  },
  [PLAN_TIERS.SCALE]: {
    maxDatasets: 2,
    maxSchemasPerDataset: 6,
    maxRecordsPerSchema: 250000,
    maxFieldsPerSchema: 16,
  },
}

export const CONTACT_SALES_URL = "https://blindinsight.com/contact"

/**
 * Returns the canonical plan tier for an organization.
 *
 * Reads `org.subscription` — the sanitized server projection that the
 * OrganizationSerializer derives from `settings.stripe` via `plans.get_plan`.
 * Shape: `{ slug: "build"|"scale"|"enterprise"|"none", display_name, active }`.
 *
 * Any active subscription with an unrecognized slug falls through to BUILD.
 */
export function getPlanTier(org) {
  const sub = org?.subscription
  if (!sub?.active) return PLAN_TIERS.FREE
  return SLUG_TO_TIER[sub.slug] ?? PLAN_TIERS.BUILD
}

/** Returns the limit object for the org's current plan. */
export function getPlanLimits(org) {
  return PLAN_LIMITS[getPlanTier(org)]
}

/**
 * Returns true if the org is on a plan with unlimited access (Scale).
 * Preserved for backward compatibility.
 */
export function isProAccount(org) {
  return getPlanTier(org) === PLAN_TIERS.SCALE
}
